import { render } from "./GeneralDetail.vue?vue&type=template&id=075c7a9d"
import script from "./GeneralDetail.vue?vue&type=script&lang=js"
export * from "./GeneralDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__